<template>
    <div class="draggable-wrapper">
        <draggable
            :value="value"
            draggable=".draggable"
            handle=".grab-item"
            filter=".disabled"
            animation="300"
            :move="onMove"
            @start="isDragging = true"
            @end="onEnd(value)"
            @input="val => $emit('input', val)"
        >
            <div
                v-for="(data, index) in value"
                :key="`groupItem${index}`"
                class="item draggable"
                :class="{
                    active: activeSno === data.sno,
                    disabled: isDisabled(data),
                    transition: !isDragging
                }"
                @click="onChange(data.sno)"
            >
                <div class="front-block">
                    <div v-if="!isGrabDisabled(data)" class="handle grab-item">
                        <div v-for="i in 2" :key="i" />
                    </div>
                    <div v-else class="handle disabled" style=""></div>
                    <span class="name">
                        <span class="name-txt">{{ data.iteM_NAM }}</span>
                        <span class="item-label" v-if="isCopy(data)">鏡像</span>
                        <span class="item-label" v-if="data.iS_SYS">系統預設</span>
                        <span class="item-mem" v-if="isShowMem">{{ data.grP_MEM }}</span>
                    </span>
                </div>
                <div v-if="isShowAccno" class="front-block">
                    <div class="accounting-setting-selector">
                        <ah-select-accounting-setting v-model="data.accsno" use-sno @change="onAccoChange($event, data)" />
                    </div>
                </div>
                <slot :sno="data.sno" :form="data.form" :disabled="isDisabled(data)" />
                <div class="back-block">
                    <div v-if="!isDisabled(data)" class="edit-btn" @click="onEdit(data)">
                        <div v-for="i in 3" :key="i" />
                    </div>
                </div>
            </div>
        </draggable>
        <div v-if="addShow" class="button-wrapper">
            <el-button size="small" @click="onAdd">
                <i class="el-icon-plus" style="margin-right: 10px" />
                新增
            </el-button>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';

export default {
    props: {
        value: Array,

        onDragEnd: { type: Function, default: () => {} },
        onAdd: { type: Function, default: () => {} },
        onChange: { type: Function, default: () => {} },
        onEdit: { type: Function, default: () => {} },

        addShow: Boolean,
        isShowMem: Boolean,
        isSysAllow: Boolean,
        isShowAccno: Boolean,
        activeSno: [Number, String],
    },
    components: { draggable, ahSelectAccountingSetting },
    data() {
        return {
            isDragging: false,
        };
    },
    methods: {
        onEnd(val) {
            this.onDragEnd(val);
            this.isDragging = false;
        },
        onMove(e) {
            if (this.isDisabled(e.relatedContext.element)) return false;
            return true;
        },
        isDisabled(data) {
            return data.disabled || (data.iS_SYS && !this.isSysAllow) || !!data.copySno;
        },
        isGrabDisabled(data) {
            return data.disabled || data.iS_SYS || !!data.copySno;
        },
        isCopy(data) {
            return (!!data.copySno && !data.fsno) || data.isshare;
        },
        async onAccoChange({ sno }, row) {
            await this.$api({
                url: '/IncomeStatementSettingPage/UpdateItem',
                method: 'POST',
                data: {
                    sno: row.sno,
                    iteM_NAM: row.iteM_NAM,
                    grP_MEM: row.grP_MEM,
                    accsno: sno,
                    isTop: row.isTop,
                },
            });
            this.$emit('update');
        },
    },
};
</script>

<style lang="scss" scoped>
.accounting-setting-selector {
    margin-right: 20px;
}
</style>

<style lang="scss">
.draggable-wrapper .accounting-setting-selector .el-cascader {
    width: 210px;
}
</style>
